import buildingGif from "icons/building/building_red.gif"
import buildingImg from "icons/building/building_red.jpg"

export default {
  img: buildingImg,
  gif: buildingGif,
}
